import React from "react";

const Card = ({
  children,
  title,
  subtitle,
  headerslot,
  className = "custom-class bg-metaxseed-dark-gray ",
  bodyClass = "p-6",
  noborder,
  titleClass = "custom-class ",
}) => {

  return (
    <div
      className={`card rounded-lg  ${
        className.includes("bg-") ? "" : "dark:bg-metaxseed-black"
      } ${className}`}
    >
      {(title || subtitle) && (
        <header className={`card-header ${noborder ? "no-border" : ""}`}>
          <div className="">
            {title && (
              <div className={`card-title text-white ${titleClass}`}>
                {title}
              </div>
            )}
            {subtitle && (
              <div className="card-subtitle text-white">{subtitle}</div>
            )}
          </div>
          {headerslot && (
            <div className="card-header-slot text-metaxseed-gray">
              {headerslot}
            </div>
          )}
        </header>
      )}
      <main className={`card-body ${bodyClass}`}>{children}</main>
    </div>
  );
};

export default Card;